import { Outlet, createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/store")({
  component: StoreLayout,
});

function StoreLayout() {
  return <Outlet />;
}
